import React from 'react'
import {
  getAllBranch
} from 'services/GeneralService';
import { useMutation, useQuery } from '@tanstack/react-query';
import { getCourierBranch } from 'services/CourierService';
import moment from 'moment-timezone';
// import { mutateDownloadRekap } from 'services/ReportCustomerServices';
import { downloadBlob } from 'lib/util';
import { Modal } from 'antd';
import AttendenceReportComponent from 'module/Report/Component/AttendanceReport/AttendanceReportComponent';
import { mutateDownloadAbsensi } from 'services/ReportAttendence';

export default function AttendenceReportContainer() {
  const [branch, setBranch] = React.useState<number | undefined>(undefined);

  const { data: dataBranchs, isFetching: isFetchingBranch } = useQuery({
    queryKey: ['getAllBranch'],
    queryFn: getAllBranch,
  });
  const { data: dataCourierBranch, isFetching: isFetchingCourier } = useQuery({
    queryKey: ['getCourierBranch', branch, true],
    queryFn: getCourierBranch,
    enabled: branch !== undefined,
  });

  const mutateDownloadReport = useMutation({
    mutationFn: mutateDownloadAbsensi,
    onSuccess(data, variables) {
      const { dateAbsensi, isMonth } = variables;

      const m = moment(dateAbsensi, 'DD/MM/YYYY', true);
      if (!m.isValid()) return console.warn('Invalid dateAbsensi:', dateAbsensi);

      const bulanID = ['Januari','Februari','Maret','April','Mei','Juni',
                      'Juli','Agustus','September','Oktober','November','Desember'];

      const title = isMonth
        ? `Laporan Absensi Bulan ${bulanID[m.month()]} ${m.format('YYYY')}`
        : `Laporan Absensi - ${m.format('YYYY-MM-DD')}`;

      downloadBlob(data.data, title, 'xls');
    },
    onError() {
      Modal.error({
        title: <b style={{ color: '#EA1A1A' }}>Gagal menjalankan proses</b>,
        content: (
          <p style={{ color: '#C0C0C0' }}>
            Terjadi kesalahan pada server, mohon hubungi admin untuk tindakan
            lebih lanjut
          </p>
        ),
      });
    },
  });

  const handleDownload = values => {
    const courier = Array.isArray(values.courier)
    ? values.courier.map(String)  
    : values.courier
      ? [String(values.courier)]
      : [];

    const payload = {
      ...values,
      dateAbsensi: moment(values.dateAbsensi).format('DD/MM/YYYY'),
      courier
    };
    mutateDownloadReport.mutate(payload);
  };

  const listBranch =
    dataBranchs?.data?.map((item: any) => ({
      id: item.id,
      name: `${item.name} (${item.uniqueCode})`,
    })) || [];

  const listCourier =
    dataCourierBranch?.map((item: any) => ({
      id: item.id,
      name: `${item.firstName} (${item.code})`,
    })) || [];

  return (
    <AttendenceReportComponent
      setPosko={setBranch}
      isLoading={
        isFetchingBranch ||
        isFetchingCourier ||
        mutateDownloadReport.isLoading
      }
      listPosko={listBranch}
      listCourier={listCourier}
      handleDownload={handleDownload}
    />
  );
}
